import * as React from 'react';
import { Link, FieldProps, useRecordContext, ReferenceManyCount } from 'react-admin';
import { Tests } from '../../custom';

const QuestionResponsesLinkField = (props: FieldProps<Tests>) => {
    const record = useRecordContext<any>();
    if (!record) {
        return null;
    }
    return (
        <Link to={`/test-series/${record.testSeriesId}/tests/${record.id}/student_responses`}>
            <div style={{ whiteSpace: 'nowrap' }}>Responses</div>
        </Link>
    );
};

QuestionResponsesLinkField.defaultProps = {
    label: 'Student Responses',
};

export default QuestionResponsesLinkField;
